export class ReactQueryConfig {
  public static staleTime = 10000;
}
